module.exports = __webpack_public_path__ + "static/media/hourglass_red_fullf1da765655862db415a2b429750df1ab.webp";